import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { headersBase, headersParams, headersType } from "../../../utils/constants/headersForApi";

export const adminCategoriesApi = createApi({
  reducerPath: "adminCategories",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["categories", "category", "mainCategories", "mainCategory"],
  endpoints: (builder) => ({
    getAdminCategories: builder.query({
      query: (accessToken = "") => ({
        url: endpoint.ADMIN_ENUM.MAIN_CATEGORIES,
        method: "GET",
        headers: headersParams(accessToken),
      }),
      providesTags: ["categories"],
    }),
    getAdminTypologies: builder.query({
      query: (accessToken = "") => ({
        url: endpoint.ADMIN_ENUM.IDENT_CATEGORIES,
        method: "GET",
        headers: headersParams(accessToken),
      }),
    }),
    getCities: builder.query({
      query: (param) => ({
        url: `admin/enums/cities?name=${param}`,
        method: "GET",
        headers: headersBase()
      }),
    }),

    getCategories: builder.query({
      query: () => ({
        url: "admin/Categories/list",
        method: "POST",
        headers: headersType(),
        body: { startRow: 0, endRow: 1000 },
      }),
      providesTags: ["categories"],
    }),
    getCategoryById: builder.query({
      query: (id) => ({
        url: `admin/Categories/${id}`,
        method: "GET",
        headers: headersBase()
      }),
      providesTags: ["category"],
    }),
    editCategory: builder.mutation({
      query: (data) => ({
        url: `admin/Categories/${data.categoryId}`,
        method: "PUT",
        headers: headersType(),
        body: data.body,
      }),
      invalidatesTags: ["categories", "category"],
    }),
    newCategory: builder.mutation({
      query: (data) => ({
        url: "admin/Categories",
        method: "POST",
        headers: headersType(),
        body: data,
      }),
      invalidatesTags: ["categories"],
    }),
    getCategoryKeywords: builder.query({
      query: (categoryId) => ({
        url: `admin/Categories/${categoryId}/keywords`,
        method: "POST",
        headers: headersType(),
        body: { startRow: 0, endRow: 1000 },
      }),
      providesTags: ["category"],
    }),
    getCategoryQueries: builder.query({
      query: (categoryId) => ({
        url: `admin/Categories/${categoryId}/queries`,
        method: "POST",
        headers: headersType(),
        body: { startRow: 0, endRow: 1000 },
      }),
      providesTags: ["category"],
    }),
    setKeywords: builder.mutation({
      query: (data) => ({
        url: `admin/Categories/${data.categoryId}/setkeywords`,
        method: "POST",
        headers: headersType(),
        body: data.keywords,
      }),
      invalidatesTags: ["categories", "category"],
    }),
    setQueries: builder.mutation({
      query: (data) => ({
        url: `admin/Categories/${data.categoryId}/setqueries`,
        method: "POST",
        headers: headersType(),
        body: data.queries,
      }),
      invalidatesTags: ["categories", "category"],
    }),
    deleteCategory: builder.mutation({
      query: (categoryId) => ({
        url: `admin/Categories/${categoryId}`,
        method: "DELETE",
        headers: headersBase()
      }),
      invalidatesTags: ["category", "categories"],
    }),
    playground: builder.query({
      query: (data) => ({
        url: `admin/documents/playground`,
        method: "POST",
        headers: headersType(),
        body: data,
      }),
    }),

    getMainCategories: builder.query({
      query: () => ({
        url: "admin/MainCategory/list",
        method: "POST",
        headers: headersType(),
        body: { startRow: 0, endRow: 1000 },
      }),
      providesTags: ["mainCategories"],
    }),
    newMainCategory: builder.mutation({
      query: (data) => ({
        url: "admin/MainCategory",
        method: "POST",
        headers: headersType(),
        body: data,
      }),
      invalidatesTags: ["mainCategories"],
    }),
    deleteMainCategory: builder.mutation({
      query: (mainCategoryId) => ({
        url: `admin/MainCategory/${mainCategoryId}`,
        method: "DELETE",
        headers: headersBase()
      }),
      invalidatesTags: ["mainCategory", "mainCategories"],
    }),
    editMacroCategory: builder.mutation({
      query: ({ id, name }) => ({
        url: `admin/MainCategory/${id}`,
        method: "PUT",
        headers: headersType(),
        body: { name: name },
      }),
      invalidatesTags: ["mainCategory", "mainCategories"],
    }),
  }),
});

export const {
  useGetAdminCategoriesQuery,
  useGetAdminTypologiesQuery,
  useGetCitiesQuery,
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useEditCategoryMutation,
  useNewCategoryMutation,
  useGetCategoryKeywordsQuery,
  useGetCategoryQueriesQuery,
  useSetKeywordsMutation,
  useSetQueriesMutation,
  useDeleteCategoryMutation,
  useLazyPlaygroundQuery,
  useNewMainCategoryMutation,
  useDeleteMainCategoryMutation,
  useGetMainCategoriesQuery,
  useEditMacroCategoryMutation,
} = adminCategoriesApi;
